<mt-no-mobile-view></mt-no-mobile-view>
<!-- Removed for now -->
<!-- <mt-cookies-banner *ngIf="!isCognismSignatures"></mt-cookies-banner> -->
<router-outlet></router-outlet>
